import * as yup from 'yup';
import { transactionCurrencyIdField } from '../../../../../../../schemas/transactions/TransactionsCommon.schema';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import { usdField } from '../../../../../../../schemas/common-schema-defs';

export function escrowFields() {
  return {
    fundId: yup.number().nullable().required().label('Fund'),
    transactionDate: transactionDateSchema().label('Payment Date'),
    escrowAmount: usdField().nullable().required().label('Cash Received'),
    currencyid: transactionCurrencyIdField(),
    notes: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
  };
}

export function escrowFormSchema() {
  return yup.object().shape(escrowFields());
}

export function escrowGridSchema() {
  return yup.object().shape(escrowFields());
}
